<template lang="jade">
  .container-fluid
    .row
      .schedule_main.col-md-12
        header.schedule_titile_bar.main_title_bar.clearfix
          h1.title.col-md-12.col-sm-10.col-xs-12 schedule
        section.schedule_content.clearfix
          table.table.table-bordered.schedule_table.hidden-md.hidden-lg
            tr
              th No.
              th Name
              th
            tr(v-for="(key ,schedule) in schedules")
              td {{ key }}
              td {{ schedule.name }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit
          table.table.table-bordered.table-striped.table-hover.schedule_table.hidden-sm.hidden-xs
            tr
              th Enabled
              th No.
              th Name
              th Action
              th Digital Output
              th Time
              th Days
              th
            tr(v-for="(key, schedule) in schedules")
              td
                i.fa.fa-check-square.fa-lg(v-if='schedule.enabled' v-on:click="setSchedule(false, key)")
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setSchedule(true, key)')
              td {{ key }}
              td {{ schedule.name }}
              td {{ actionTranslator(schedule.action) }}
              td.targets.no_pad
                div(v-for="(key, target) in schedule.targets")
                  span.clearfix(v-bind:data-target='target') [DO{{target}}] {{DOs[target].name}}
              td {{ schedule.time.hours.toString().length === 1 ? '0' + schedule.time.hours : schedule.time.hours }}:{{schedule.time.minutes.toString().length === 1 ? '0'+schedule.time.minutes : schedule.time.minutes }}
              td.weekDay
                span.day(v-for='(key,day) in weekDay' v-bind:class="{enabled:schedule.time.days.indexOf(day) !== -1}")
                  |{{ day }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit.fa-lg
  modal.popout.schedule_config(
    v-bind:show.sync='showModal'
    v-bind:title='editing.title'
    effect='zoom'
    v-bind:callback='handleScheduleConfig'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body(slot="modal-body")
      table.table.table-bordered.schedule_config_table
        tr
          th Enabled
          td.enabled
            input(type="checkbox" v-model="editing.schedule.enabled" id='schedule{{editing.schedule.no}}')
            label(for="schedule{{editing.schedule.no}}")
              i.fa.fa-check-square.fa-lg(v-show='editing.schedule.enabled')
              i.fa.fa-square-o.fa-lg(v-else)
              |Enabled
        tr
          th Name
          td
            validator(name='scheName')
              input.form-control(type="text" v-model="new_schedule_name"
                    v-bind:value="editing.schedule.name" maxLength='7' v-validate:name="['engAndNum']")
              span.error(v-show='$scheName.name.invalid && $scheName.name.modified')
                |English Charactor ,numbers and '_' only
        tr
          th Digital Output
          td.banks.col-xs-10
            v-multi-banks(v-bind:name-prop='target'
                          v-bind:options.sync='targetOptions'
                          v-bind:output-ary.sync='editing.newTargets')
        tr
          th Action
          td
            v-select(v-bind:options.sync="actionOptions"
                     v-bind:value.sync='editing.schedule.action')
        tr
          th Days
          td.weekDay
            span.clearfix(v-for='(key,day) in weekDay')
              input.weekDay_checkbox(type="checkbox" value='{{day}}' v-bind:checked="editing.schedule.time.days.indexOf(day) !== -1" id="{{day}}{{key}}" v-model='editing.newDays')
              label.weekDay_label(for="{{day}}{{key}}") {{ day }}
        tr
          th Time
          td.time.col-xs-10
            input.form-control-inline(type='number' max='23' min='0' v-model='editing.schedule.time.hours')
            span &nbsp;:&nbsp;
            input.form-control-inline(type='number' max="59" min='0' v-model='editing.schedule.time.minutes')

</template>

<script>
import { modal } from 'vue-strap'
import _ from 'lodash'
import select from 'src/components/Single-Select.vue'
import { call } from 'src/Service.js'
import multiBanks from 'src/components/Multi-Banks.vue'
import $ from 'jquery'

export default {
  components: {
    modal,
    'v-select': select,
    'v-multi-banks': multiBanks
  },
  data () {
    return {
      DIs: {},
      DOs: {},
      editing: {
        title: 'Schedule Config',
        index: '',
        schedule: null,
        newTargets: [1],
        newDays: []
      },
      schedules: {},
      showModal: false,
      new_schedule_name: '',
      weekDay: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      actionOptions: [
        {label: 'Turn on', value: 'DO High'},
        {label: 'Turn off', value: 'DO Low'}
      ]
    }
  }, // close data
  computed: {
    targetOptions () {
      let options = []
      for (let key in this.DOs) {
        options.push({
          label: `[DO${key}] ` + this.DOs[key].name,
          value: `${key}`
        })
      }
      return options
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    call(mac, 'dxGetSchedules').then(({entries}) => {
      this.schedules = _.cloneDeep(entries)
      return call(mac, 'dxGetDIOStatus')
    }).then(({channels}) => {
      this.DIs = _.cloneDeep(channels.DIs)
      this.DOs = _.cloneDeep(channels.DOs)
    }).catch(err => {
      this.alert('danger', '', err)
    })
  },
  methods: {
    actionTranslator (action) {
      console.log(action)
      if (action === 'DO High') {
        return 'Turn On'
      } else if (action === 'DO Low') {
        return 'Turn Off'
      } else {
        return ''
      }
    },
    setSchedule (enabled, scheduleKey) {
      let param = {
        entries: {
          [scheduleKey]: this.schedules[scheduleKey]
        }
      }
      param.entries[scheduleKey].enabled = enabled
      call(this.$route.params.mac, 'dxSetSchedules', param).then(res => {
        console.log(res)
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    toShowModal (key) {
      this.editing.index = key
      this.editing.title = 'Schedule Config ' + key
      this.editing.schedule = _.cloneDeep(this.schedules[key])
      this.editing.newTargets = this.editing.schedule.targets
      this.editing.newDays = this.editing.schedule.time.days
      this.showModal = true
    },
    handleScheduleConfig () {
      // name validation
      if (this.$scheName.invalid) return this.alert('danger', '', 'Please enter a valid schedule name')

      // action validation
      if (!this.editing.schedule.action) return this.alert('danger', '', 'Please give this schedule an action')

      // Time validation
      let regexNum = /^[0-9]{1,2}/
      if (!regexNum.test(this.editing.schedule.time.hours) || !regexNum.test(this.editing.schedule.time.minutes) || this.editing.schedule.time.hours.length > 2 || this.editing.schedule.time.minutes.length > 2) return this.alert('danger', '', 'Please enter valid times')

      if (this.editing.schedule.time.hours < 0 || this.editing.schedule.time.minutes < 0 || this.editing.schedule.time.hours > 23 || this.editing.schedule.time.minutes > 59) {
        return this.alert('danger', '', 'Please enter right format of time (ex: 14:59)')
      }

      // Need at least a day to activate schedule
      if (this.editing.newDays.length === 0) {
        return this.alert('danger', '', 'Please choose a day for your schedule to active')
      }

      // Schedule must have a target
      if (this.editing.newTargets.length === 0) {
        return this.alert('danger', '', 'Please give your schedule an output')
      }

      let sche = _.cloneDeep(this.editing.schedule)
      sche.name = this.new_schedule_name.trim() // trim ' ' of the both sides
      sche.targets = _.cloneDeep(this.editing.newTargets)
      sche.time.days = _.cloneDeep(this.editing.newDays)

      // Schedule can not conflict to other schedule
      let conflict = []
      let toCheckSche = []
      let keys = Object.keys(this.schedules)
      for (let k of keys) {
        let s = this.schedules[k]
        if (s.action !== sche.action && s.time.hours === parseInt(sche.time.hours) && s.time.minutes === parseInt(sche.time.minutes) && parseInt(k) !== parseInt(this.editing.index)) toCheckSche.push(s)
      }

      // targets, time.days 2 array remain
      conflict = toCheckSche.map(s => {
        let hasSameTarget = false
        let hasSameDay = false

        for (let tar in s.targets) {
          if (sche.targets.indexOf(tar) !== -1) {
            hasSameTarget = true
            break
          }
        }

        for (let day of s.time.days) {
          if (sche.time.days.indexOf(day) !== -1) {
            hasSameDay = true
            break
          }
        }

        if (hasSameDay && hasSameTarget) return s
      })

      conflict = conflict.filter(c => c)
      console.log('length of conflict', conflict.length)
      if (conflict.length !== 0) return this.alert('danger', '', 'The schedule you set has conflict with others')

      let param = {
        entries: {
          [this.editing.index]: sche
        }
      }
      call(this.$route.params.mac, 'dxSetSchedules', param).then(res => {
        console.log(res)
        this.showModal = false
      }, err => {
        console.log(err)
      })
    }
  },
  ready () {
  },
  events: {
    update (mac, {type, event, msg}) {
      // update the data when received
      console.log(type)
      console.log(event)
      console.log(msg)
      if (type === 'schedule') {
        this.schedules = _.assignIn(this.schedules, event)
      }
    }
  },
  watch: {
    showModal (nv) {
      if (!nv) {
        $('.schedule_config').scrollTop(0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  table th {
    text-align: center;
  }
  .schedule_table {
    margin-top: $space_sm;
    text-align: center;
    & th{
      text-align: center;
    }
    .targets{
      min-width: 250px;
      text-align: center;
      & > div{
        padding-left: 0;
        padding-right: 0;
        margin-left: $space_xxs;
        margin-right: $space_xxs;
        margin-top: 5px;
        max-width: 33%;
        float: left;
      }
      span{
        color: $DioSchedule_output_tag_fg;
        background-color: $DioSchedule_output_tag_bg;
        padding: 3px 10px;
        border-radius: $base_border_radius;
        white-space: nowrap;
        text-align: center;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        // @each $i in $window_colors{
        //   &[data-target='#{nth($i, 1)}']{
        //     background-color: #{nth($i, 2)}
        //   }
        // }
      }
    }
    .weekDay{
      & .day{
        text-transform: uppercase;
        padding-left: 5px;
        padding-right: 5px;
        opacity: .3;
        &.enabled{
          color: $DioSchedule_day_enabled;
          opacity: 1;
        }
      }
    }
  }
  .schedule_config_table{
    th {
      text-transform: capitalize;
    }
    /* ============ global weekDay and outlets style ==================== */
    .weekDay,.banks{
      width: 100%;
      position: relative;
      span{
        float: left;
        font-size: 14px;
        padding-left: 5px;
        padding-right: 5px;
        text-transform: uppercase;
      }
      label{
        cursor: pointer;
      }
    }
    .enabled{
      position: relative;
      padding-left: 30px;
      input{
        position: absolute;
        left: -9999px;
      }
      .fa{
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
    /* =========== outlets ======================= */
    .banks{
      & span:first-child .bank_checkbox:checked + .bank_label{
        background-color: $input_red;
      }
      & span:nth-child(2) .bank_checkbox:checked + .bank_label{
        background-color: $bank_blue;
      }
      & span:last-child .bank_checkbox:checked + .bank_label{
        background-color: $bank_green;
      }
    }
    .bank_checkbox{
      position: absolute;
      left: -9999px;
    }

    /* =========== weekDay ================== */
    .weekDay_checkbox{
      position: absolute;
      left: -9999px;
      &:checked + .weekDay_label{
        background-color: $MultiBanks_checked_bg;
        color: $MultiBanks_checked_fg;
      }
    }
    .weekDay_label,.bank_label{
      width: 100%;
      padding: 5px 3px;
      background-color: $MultiBanks_unchecked_bg;
      color: $MultiBanks_unchecked_fg;
    }

    .weekDay_label {
      @include breakpoint(lg){
        padding: 10px 8px;
        font-size: 14px;
      }
      @include breakpoint(md){
        padding: 10px 8px;
        font-size: 14px;
      }
    }
    /* ========== time ===================== */
    .time{
      & input[type=number]::-webkit-inner-spin-button,
      & input[type=number]::-webkit-outer-spin-button{
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
      }
      & input[type=number]{
        -moz-appearance: textfield;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// Schedule.vue?6d8a76df